<div class="d-flex container-professional">
  <ng-container *ngFor="let item of profesional">
    <div class="w-100 pointer profesional-item d-flex align-items-center justify-content-center" [ngClass]="{'selected': item.selected}" (click)="changeSelected(item)" [ngStyle]="{'background': item.color} ">
      <div>
        <div class="w-100 text-center mb-3">
          <img [src]="item.image" alt="icon-profesional.svg" width="56">
        </div>
        <div class="text-center">
          <span class="fs-4 bold text-white">{{item.title}}</span>
        </div>
      </div>
    </div>
  </ng-container>
</div>
<div class="py-4 py-sm-5 padding-custom">
  <router-outlet></router-outlet>
</div>